import {
  QueryClient,
  QueryClientProvider,
  useIsFetching,
} from "@tanstack/react-query";
import RouterMain from "./pages/router/RouterMain";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Amplify } from "aws-amplify";
import amplifyconfig from "./amplifyconfiguration.json";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./components/error-boundary/ErrorFallback";

Amplify.configure(amplifyconfig);

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false, // Ensure this setting is applied
        onError: (error) => {
          console.error("Global Query Error:", error);
        },
      },
    },
  });
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <ErrorBoundary fallbackRender={ErrorFallback}>
          <RouterMain />
        </ErrorBoundary>
      </QueryClientProvider>
    </div>
  );
}

export default App;
